import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { languages } from './shared/constants/app-enums';

@Injectable({
  providedIn: 'root'
})
export class LangGuardGuard implements CanActivate {
  constructor(private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const langCodes: string[] = [];
    languages.forEach((lang) => {
      langCodes.push(lang.value)
    })
    if (!route.params['lang']) {
      return true;
    } else {
      if (!langCodes.includes(route.params['lang'])) {
        this.router.navigateByUrl('./404')
        console.log(route);

        return true;
      } else {
        return true
      }
    }

    console.log(route);


    return langCodes.includes(route.params['lang']);
  }

}
